import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=3f9c7ec2&scoped=true&"
import script from "./complain.vue?vue&type=script&lang=js&"
export * from "./complain.vue?vue&type=script&lang=js&"
import style0 from "./complain.vue?vue&type=style&index=0&id=3f9c7ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c7ec2",
  null
  
)

component.options.__file = "complain.vue"
export default component.exports